import { render, staticRenderFns } from "./free_vs_premium_comparison_table.vue.js?vue&type=template&id=0f77e846!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=template&id=0f77e846"
import script from "./free_vs_premium_comparison_table.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=script&lang=js"
export * from "./free_vs_premium_comparison_table.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=script&lang=js"
import style0 from "./free_vs_premium_comparison_table.vue.css?vue&type=style&index=0&id=0f77e846&prod&lang=css!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./free_vs_premium_comparison_table.vue?vue&type=style&index=0&id=0f77e846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports